import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyTileContentSectionComponent } from './tile-content-section.component';
import { SkyTileContentComponent } from './tile-content.component';


export class SkyTileContentModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyTileContentComponent,
    SkyTileContentSectionComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SkyTileContentComponent,
    SkyTileContentSectionComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
